import { useContext } from 'react';
import { StateContext } from '../contexts/StateContext';

export const useStateContext = () => {
  const state = useContext(StateContext);

  if (!state) {
    throw new Error('StateContext.Provider not found');
  }

  return state;
};
